import { render } from "./NotifyMe.vue?vue&type=template&id=fe63bfce&scoped=true"
import script from "./NotifyMe.vue?vue&type=script&lang=js"
export * from "./NotifyMe.vue?vue&type=script&lang=js"

import "./NotifyMe.vue?vue&type=style&index=0&id=fe63bfce&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe63bfce"]])

export default __exports__